import AfterDoc from '@/components/ui/AfterDoc';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouContactUs = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t('Oczekuj na połączenie telefoniczne')}
      withButton
      productId={PRODUCT.HOUSE_HOLD}
    >
      <span>
        {i18n.t(
          'Twoja sprawa wymaga dodatkowych informacji dotyczących szkody. Prosimy o cierpliwość. Nasz konsultant wkrótce skontaktuje się z Tobą telefonicznie, aby omówić szczegóły.'
        )}
      </span>
      <span className="font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </span>
    </AfterDoc>
  );
};

export default ThankYouContactUs;
